import React, {useEffect, useState} from 'react';
import './NewOrderForm.scss';
import {useLocation, useNavigate} from "react-router-dom";
import Loader from "../../../Loader";
import _axios from "../../../../httpService";
import {prefixUrl} from "../../../../utils/utilsData";
import {toast} from "react-toastify";
import {ArrowIcon, DeleteIcon, ShowIcon} from "../ExportIcons/ExportIcons";
import DynaInput from "../../DynaView/DynaInput";
import DynaTextarea from "../../DynaView/DynaTextarea";
import DynaSelectBox from "../../DynaView/DynaSelectBox";
import {SubmitDataHandler} from "./SubmitDataHandler";
import UtilsFunctions from "../../../../utils/UtilsFunctions";

const NewOrderForm = () => {

  const myLocation = useLocation();
  const navigateTo = useNavigate();
  const [initialData, setInitialData] = useState({});
  const [isLoad, setIsLoad] = useState(false);
  const [sendData, setSendData] = useState({
    mode: 'add',
    request_id: '',
    leadId: '',
    fullName_1: '',
    phoneNumber_1: '',
    national_id_1: '',
    fullName_2: '',
    phoneNumber_2: '',
    national_id_2: '',
    emailAddress: "",
    postalCode: "",
    telephone: "",
    address: "",
    groupFullName: '',
    ownerShip: '',
    ownerShipType: '',
    activityType: '',
    activityDescription: '',
    hasSite: 0,
    siteLink: '',
    hasDomain: 0,
    domainName: '',
    electronicSymbol: 0,
    paymentGateway: 0,
    economicId: '',
    bankName: '',
    shebaNumber: '',
    accountNumber: '',
    hasAgent: 0,
    agentAddress: '',
    googleMap: '',
    status: '',
    electronicSymbolStatus: '',
    paymentGatewayStatus: '',
    modules: [],
    socialMedia: [],
    nationalCard: null,
    nationalCard_link: "",
    license: null,
    license_link: "",
    duty: null,
    duty_link: "",
    birthCertificate: null,
    birthCertificate_link: "",
    lastNames: null,
    lastNames_link: "",
    lastActivities: null,
    lastActivities_link: "",
    lastAddress: null,
    lastAddress_link: "",
    mainStatute: null,
    mainStatute_link: "",
    personType: "حقیقی",
    factorDescription: "",
    agreedPrice: "",
  });
  const [file, setFile] = useState({
    nationalCard: [],
    license: [],
    duty: [],
    birthCertificate: [],
    lastNames: [],
    lastActivities: [],
    lastAddress: [],
    mainStatute: [],
  });
  const [fileName, setFileName] = useState({
    nationalCard: "کارت ملی را بارگذاری کنید",
    license: "مجوز فعالیت را بارگذاری کنید",
    duty: "مدرک وضعیت نظام وظیفه را بارگذاری کنید",
    birthCertificate: "شناسنامه را بارگذاری کنید",
    lastNames: "آخرین تغییرات اسامی را بارگذاری کنید",
    lastActivities: "آخرین تغییرات فعالیت را بارگذاری کنید",
    lastAddress: "آخرین تغییرات آدرس را بارگذاری کنید",
    mainStatute: "اصل اساسنامه را بارگذاری کنید",
  });
  const [deletedFiles, setDeletedFiles] = useState([])
  const [getInitialDataStatus, setGetInitialDataStatus] = useState(false);
  const [isPending, setIsPending] = useState(false)

  const getInitialData = async () => {
    setIsLoad(false)
    const response = await _axios.get(prefixUrl() + "/hiSite/?request=initialData")
    if (response?.data?.status) {
      setInitialData(response.data.data)
      if (myLocation?.state?.pkValue) {
        setSendData({...sendData, leadId: myLocation.state?.pkValue})
      }
      if (myLocation?.state?.mode !== "edit") {
        setIsLoad(true)
      }
      setGetInitialDataStatus(true)
    } else {
      toast.error(response.data.message)
    }
  }

  const getEditModeData = async () => {
    const response = await _axios.get(prefixUrl() + "/hiSite/?request=requestSubmittedData&requestId=" + myLocation?.state?.id)
    if (response?.data?.status) {
      const updatedData = initialData?.modules.map(item => {
        const editItem = response.data.data.modules.find(edit => edit.id === item.id);
        if (editItem) {
          return {...item, ...editItem, check: "1"};
        }
        return item;
      });
      const updatedSocialMedia = initialData?.socialMedia.map(item => {
        const editItem = response.data.data.socialMedia.find(edit => edit.id === item.id);
        if (editItem) {
          return {...item, ...editItem, link: editItem.link};
        }
        return item;
      });
      setSendData({...sendData, ...response.data.data})
      setInitialData({...initialData, modules: updatedData, socialMedia: updatedSocialMedia})
      setIsLoad(true)
    } else {
      toast.error(response.data.message)
    }
  }

  useEffect(() => {
    void getInitialData()
  }, []);

  useEffect(() => {
    if (myLocation?.state?.mode === "edit" && Object.keys(initialData).length > 0) {
      void getEditModeData()
    }
  }, [getInitialDataStatus]);

  const modulesHandler = (checked, id) => {
    const temp = [...initialData?.modules]
    temp.forEach((item) => {
      if (item.id === id) {
        item.check = checked ? 1 : 0
      }
    })
    setInitialData({...initialData, modules: temp})
  }

  const linkChangeHandler = (value, id) => {
    const temp = [...initialData?.socialMedia]
    temp.forEach((item) => {
      if (item.id === id) {
        item.link = value
      }
    })
    setInitialData({...initialData, socialMedia: temp})
  }

  const submitDataHandler = async () => {
    setIsPending(true)
    try {
      await SubmitDataHandler(sendData, initialData, file, navigateTo, deletedFiles, setIsPending);
    } catch (error) {
      toast.error('خطایی در ارسال درخواست رخ داده است');
    }
  }

  const handleFileChange = (event, inputName) => {
    const selectedFiles = Array.from(event.target.files);
    const imageFile = selectedFiles.find((file) =>
      file.type.startsWith('image/')
    );
    if (imageFile) {
      const fileURL = URL.createObjectURL(imageFile);
      setFile((prevFile) => ({
        ...prevFile,
        [inputName]: imageFile
      }));
      setFileName((prevFileNames) => ({
        ...prevFileNames,
        [inputName]: imageFile.name
      }));
      setSendData((prevData) => ({
        ...prevData,
        [`${inputName}_link`]: fileURL
      }));
    } else {
      toast.error('فرمت فایل نا معتبر است');
    }
  };

  const deleteFileHandler = (name) => {
    setFile((prevFile) => ({
      ...prevFile,
      [name]: []
    }));
    setFileName((prevFileNames) => ({
      ...prevFileNames,
      [name]: "فایل را بارگذاری کنید"
    }));
    setSendData((prevData) => ({
      ...prevData,
      [`${name}_link`]: "",
      [`${name}`]: null
    }));
    document.getElementById(name).value = "";

    if (sendData?.mode === "edit") {
      let temp = [...deletedFiles]
      temp.push(sendData[`${name}_path`]);
      setDeletedFiles(temp)
    }
  }

  try {
    return (
      <>
        {isLoad ?
          <section className={"NewOrderForm"}>

            <section className={"parent-section"}>
              <div className={"title-side"}>
                <ArrowIcon/>
                <h5>اطلاعات پایه</h5>
              </div>
              <div className={"form-side"} style={{gridTemplateColumns: "repeat(3, 1fr)"}}>
                <DynaInput label={"نام و نام خانوادگی نفر اول *"}
                           name={"fullName_1"}
                           className={"solid-dyna-input"}
                           placeholder={"نام و نام خانوادگی نفر اول را وارد کنید"}
                           value={sendData?.fullName_1}
                           type={"text"}
                           setDataFromComponent={(data) => {
                             setSendData({...sendData, ...data})
                           }}
                />
                <DynaInput label={"شماره تماس *"}
                           name={"phoneNumber_1"}
                           className={"solid-dyna-input"}
                           placeholder={"شماره تماس اول را وارد کنید"}
                           value={sendData?.phoneNumber_1}
                           type={"number"}
                           setDataFromComponent={(data) => {
                             setSendData({...sendData, ...data})
                           }}
                />
                <DynaInput label={"کد ملی"}
                           name={"national_id_1"}
                           className={"solid-dyna-input"}
                           placeholder={"کد ملی را وارد کنید"}
                           value={sendData?.national_id_1}
                           type={"text"}
                           setDataFromComponent={(data) => {
                             setSendData({...sendData, ...data})
                           }}
                />
                <DynaInput label={"نام و نام خانوادگی نفر دوم"}
                           name={"fullName_2"}
                           className={"solid-dyna-input"}
                           placeholder={"نام و نام خانوادگی نفر اول را وارد کنید"}
                           value={sendData?.fullName_2}
                           type={"text"}
                           setDataFromComponent={(data) => {
                             setSendData({...sendData, ...data})
                           }}
                />
                <DynaInput label={"شماره تماس"}
                           name={"phoneNumber_2"}
                           className={"solid-dyna-input"}
                           placeholder={"شماره تماس اول را وارد کنید"}
                           value={sendData?.phoneNumber_2}
                           type={"text"}
                           setDataFromComponent={(data) => {
                             setSendData({...sendData, ...data})
                           }}
                />
                <DynaInput label={"کد ملی"}
                           name={"national_id_2"}
                           className={"solid-dyna-input"}
                           placeholder={"کد ملی را وارد کنید"}
                           value={sendData?.national_id_2}
                           type={"number"}
                           setDataFromComponent={(data) => {
                             setSendData({...sendData, ...data})
                           }}
                />
              </div>
            </section>

            <section className={"parent-section"}>
              <div className={"title-side"}>
                <ArrowIcon/>
                <h5>اطلاعات مجموعه</h5>
              </div>
              <div className={"form-side"}>
                <div style={{gridColumn: "1/-1"}}>
                  <DynaInput label={"نام کامل مجموعه *"}
                             name={"groupFullName"}
                             className={"solid-dyna-input"}
                             placeholder={"نام کامل مجموعه را وارد کنید"}
                             value={sendData?.groupFullName}
                             type={"text"}
                             setDataFromComponent={(data) => {
                               setSendData({...sendData, ...data})
                             }}
                  />
                </div>
                <DynaInput label={"مالکیت"}
                           name={"ownerShip"}
                           className={"solid-dyna-input"}
                           placeholder={"مالکیت را وارد کنید"}
                           value={sendData?.ownerShip}
                           type={"text"}
                           setDataFromComponent={(data) => {
                             setSendData({...sendData, ...data})
                           }}
                />
                <DynaInput label={"ایمیل فعال"}
                           name={"emailAddress"}
                           className={"solid-dyna-input"}
                           placeholder={"ایمیل فعال را وارد کنید"}
                           value={sendData?.emailAddress}
                           type={"text"}
                           setDataFromComponent={(data) => {
                             setSendData({...sendData, ...data})
                           }}
                />
                <DynaInput label={"کد پستی"}
                           name={"postalCode"}
                           className={"solid-dyna-input"}
                           placeholder={"ک دپستی را وارد کنید"}
                           value={sendData?.postalCode}
                           type={"number"}
                           setDataFromComponent={(data) => {
                             setSendData({...sendData, ...data})
                           }}
                />
                <DynaInput label={"خط ثابت"}
                           name={"telephone"}
                           className={"solid-dyna-input"}
                           placeholder={"خط ثابت را وارد کنید"}
                           value={sendData?.telephone}
                           type={"number"}
                           setDataFromComponent={(data) => {
                             setSendData({...sendData, ...data})
                           }}
                />
                <div className="radio-button-group">
                  <h5>مالکیت مجموعه</h5>
                  <div className={"parent-row"}>
                    {initialData?.ownerShipType.map((item, index) => (
                      <label key={index + "ownerShipType"} className="radio-label">
                        <input
                          type="radio"
                          name="category"
                          value={item.value}
                          checked={sendData?.ownerShipType === item.value}
                          onChange={() => setSendData({...sendData, ownerShipType: item?.value})}
                          className="radio-input"
                        />
                        <span className="custom-radio"></span>
                        {item.label}
                      </label>
                    ))}
                  </div>
                </div>
                <div className="radio-button-group">
                  <h5>نوع زمینه فعالیت مجموعه</h5>
                  <div className={"parent-row"}>
                    {initialData?.activityType.map((item, index) => (
                      <label key={index + "activityType"} className="radio-label">
                        <input
                          type="radio"
                          name="activityType"
                          value={item.value}
                          checked={sendData?.activityType === item.value}
                          onChange={() => setSendData({...sendData, activityType: item?.value})}
                          className="radio-input"
                        />
                        <span className="custom-radio"></span>
                        {item.label}
                      </label>
                    ))}
                  </div>
                </div>
                <div style={{gridColumn: "1/-1"}}>
                  <DynaTextarea label={"آدرس"}
                                name={"address"}
                                style={{height: '100px'}}
                                className={"solid-dyna-input"}
                                placeholder={"آدرس را وارد کنید"}
                                value={sendData?.address}
                                type={"text"}
                                setDataFromComponent={(data) => {
                                  setSendData({...sendData, ...data})
                                }}
                  />
                </div>
              </div>
            </section>

            <section className={"parent-section"}>
              <div className={"title-side"}>
                <ArrowIcon/>
                <h5>شرح مختصر زمینه های فعالیت مجموعه</h5>
              </div>
              <div className={"form-side"}>
                <div style={{gridColumn: "1/-1"}}>
                  <DynaTextarea label={"توضیحات"}
                                name={"activityDescription"}
                                style={{height: '140px'}}
                                className={"solid-dyna-input"}
                                placeholder={"توضیحات را وارد کنید"}
                                value={sendData?.activityDescription}
                                type={"text"}
                                setDataFromComponent={(data) => {
                                  setSendData({...sendData, ...data})
                                }}
                  />
                </div>
              </div>
            </section>

            <section className={"parent-section"}>
              <div className={"title-side"}>
                <ArrowIcon/>
                <h5>سابقه وبسایت پیشین</h5>
              </div>
              <div className={"form-side"}>
                <div className="radio-button-group">
                  <h5>سابقه فروشگاه اینترنتی</h5>
                  <div className={"parent-row"}>
                    <label className="radio-label">
                      <input
                        type="checkbox"
                        name="hasSite"
                        checked={sendData?.hasSite}
                        onChange={(e) => setSendData({...sendData, hasSite: e.target.checked === true ? 1 : 0})}
                      />
                      <span className="custom-checkbox"></span>
                      سایت دارم
                    </label>
                    <label className="radio-label">
                      <input
                        type="checkbox"
                        name="hasDomain"
                        checked={sendData?.hasDomain}
                        onChange={(e) => setSendData({...sendData, hasDomain: e.target.checked === true ? 1 : 0})}
                      />
                      دامنه دارم
                    </label>
                  </div>
                </div>
                <div></div>
                {sendData?.hasSite === 1 &&
                  <DynaInput label={"نام سایت *"}
                             name={"siteLink"}
                             className={"solid-dyna-input"}
                             placeholder={"نام سایت را وارد کنید"}
                             value={sendData?.siteLink}
                             type={"text"}
                             setDataFromComponent={(data) => {
                               setSendData({...sendData, ...data})
                             }}
                  />}
                {sendData?.hasDomain === 1 &&
                  <DynaInput label={"نام دامنه *"}
                             name={"domainName"}
                             className={"solid-dyna-input"}
                             placeholder={"نام دامنه را وارد کنید"}
                             value={sendData?.domainName}
                             type={"text"}
                             setDataFromComponent={(data) => {
                               setSendData({...sendData, ...data})
                             }}
                  />}
              </div>
            </section>

            <section className={"parent-section"}>
              <div className={"title-side"}>
                <ArrowIcon/>
                <h5>اینماد</h5>
              </div>
              <div className={"form-side"}>
                <div className="radio-button-group">
                  <div className={"parent-row"}>
                    <label className="radio-label">
                      <input
                        type="checkbox"
                        name="electronicSymbol"
                        checked={sendData?.electronicSymbol}
                        onChange={(e) => setSendData({
                          ...sendData,
                          electronicSymbol: e.target.checked === true ? 1 : 0
                        })}
                      />
                      <span className="custom-checkbox"></span>
                      اینماد
                    </label>
                  </div>
                </div>
                {sendData?.electronicSymbol === 1 &&
                  <div className="radio-button-group">
                    <div className={"parent-row"}>
                      <label className="radio-label">
                        <input
                          type="radio"
                          name="personType"
                          value={"حقیقی"}
                          checked={sendData?.personType === "حقیقی"}
                          onChange={() => setSendData({...sendData, personType: "حقیقی"})}
                          className="radio-input"
                        />
                        <span className="custom-radio"></span>
                        شخص حقیقی
                      </label>
                      <label className="radio-label">
                        <input
                          type="radio"
                          name="personType"
                          value={"حقوقی"}
                          checked={sendData?.personType === "حقوقی"}
                          onChange={() => setSendData({...sendData, personType: "حقوقی"})}
                          className="radio-input"
                        />
                        <span className="custom-radio"></span>
                        شخص حقوقی
                      </label>
                    </div>
                  </div>
                }
                {sendData?.electronicSymbol === 1 && sendData?.personType === "حقیقی" &&
                  <div className={"parent-file-upload"}>
                    <label>شناسنامه *</label>
                    <button onClick={() => document.getElementById("birthCertificate").click()}
                            className={"upload-file-but"}>
                      {fileName?.birthCertificate}
                    </button>
                    <input style={{display: "none"}} type={"file"} id={"birthCertificate"}
                           onChange={(e) => handleFileChange(e, "birthCertificate")}/>
                    {sendData?.birthCertificate_link !== "" &&
                      <a className={"show-link"} href={sendData?.birthCertificate_link}
                         target={"_blank"}><ShowIcon/></a>}
                    {sendData?.birthCertificate_link !== "" &&
                      <button className={"delete-file"}
                              onClick={() => deleteFileHandler("birthCertificate")}><DeleteIcon/></button>}
                  </div>
                }
                {sendData?.electronicSymbol === 1 && sendData?.personType === "حقیقی" &&
                  <div className={"parent-file-upload"}>
                    <label>مدرک وضعیت نظام وظیفه *</label>
                    <button onClick={() => document.getElementById("duty").click()} className={"upload-file-but"}>
                      {fileName?.duty}
                    </button>
                    <input style={{display: "none"}} type={"file"} id={"duty"}
                           onChange={(e) => handleFileChange(e, "duty")}/>
                    {sendData?.duty_link !== "" &&
                      <a className={"show-link"} href={sendData?.duty_link} target={"_blank"}><ShowIcon/></a>}
                    {sendData?.duty_link !== "" &&
                      <button className={"delete-file"}
                              onClick={() => deleteFileHandler("duty")}><DeleteIcon/></button>}
                  </div>
                }
                {sendData?.electronicSymbol === 1 && sendData?.personType === "حقوقی" &&
                  <div className={"parent-file-upload"}>
                    <label>نامه اصل اساسنامه *</label>
                    <button onClick={() => document.getElementById("mainStatute").click()}
                            className={"upload-file-but"}>
                      {fileName?.mainStatute}
                    </button>
                    <input style={{display: "none"}} type={"file"} id={"mainStatute"}
                           onChange={(e) => handleFileChange(e, "mainStatute")}/>
                    {sendData?.mainStatute_link !== "" &&
                      <a className={"show-link"} href={sendData?.mainStatute_link} target={"_blank"}><ShowIcon/></a>}
                    {sendData?.mainStatute_link !== "" &&
                      <button className={"delete-file"}
                              onClick={() => deleteFileHandler("mainStatute")}><DeleteIcon/></button>}
                  </div>
                }
                {sendData?.electronicSymbol === 1 && sendData?.personType === "حقوقی" &&
                  <div className={"parent-file-upload"}>
                    <label>نامه آخرین تغییرات اسامی</label>
                    <button onClick={() => document.getElementById("lastNames").click()}
                            className={"upload-file-but"}>
                      {fileName?.lastNames}
                    </button>
                    <input style={{display: "none"}} type={"file"} id={"lastNames"}
                           onChange={(e) => handleFileChange(e, "lastNames")}/>
                    {sendData?.lastNames_link !== "" &&
                      <a className={"show-link"} href={sendData?.lastNames_link} target={"_blank"}><ShowIcon/></a>}
                    {sendData?.lastNames_link !== "" &&
                      <button className={"delete-file"}
                              onClick={() => deleteFileHandler("lastNames")}><DeleteIcon/></button>}
                  </div>
                }
                {sendData?.electronicSymbol === 1 && sendData?.personType === "حقوقی" &&
                  <div className={"parent-file-upload"}>
                    <label>نامه آخرین تغییرات فعالیت</label>
                    <button onClick={() => document.getElementById("lastActivities").click()}
                            className={"upload-file-but"}>
                      {fileName?.lastActivities}
                    </button>
                    <input style={{display: "none"}} type={"file"} id={"lastActivities"}
                           onChange={(e) => handleFileChange(e, "lastActivities")}/>
                    {sendData?.lastActivities_link !== "" &&
                      <a className={"show-link"} href={sendData?.lastActivities_link} target={"_blank"}><ShowIcon/></a>}
                    {sendData?.lastActivities_link !== "" &&
                      <button className={"delete-file"}
                              onClick={() => deleteFileHandler("lastActivities")}><DeleteIcon/></button>}
                  </div>
                }
                {sendData?.electronicSymbol === 1 && sendData?.personType === "حقوقی" &&
                  <div className={"parent-file-upload"}>
                    <label>نامه آخرین تغییرات آدرس</label>
                    <button onClick={() => document.getElementById("lastAddress").click()}
                            className={"upload-file-but"}>
                      {fileName?.lastAddress}
                    </button>
                    <input style={{display: "none"}} type={"file"} id={"lastAddress"}
                           onChange={(e) => handleFileChange(e, "lastAddress")}/>
                    {sendData?.lastAddress_link !== "" &&
                      <a className={"show-link"} href={sendData?.lastAddress_link} target={"_blank"}><ShowIcon/></a>}
                    {sendData?.lastAddress_link !== "" &&
                      <button className={"delete-file"}
                              onClick={() => deleteFileHandler("lastAddress")}><DeleteIcon/></button>}
                  </div>
                }
              </div>
            </section>

            <section className={"parent-section"}>
              <div className={"title-side"}>
                <ArrowIcon/>
                <h5> درگاه پرداخت</h5>
              </div>
              <div className={"form-side"}>
                <div className="radio-button-group">
                  <div className={"parent-row"}>
                    <label className="radio-label">
                      <input
                        type="checkbox"
                        name="paymentGateway"
                        checked={sendData?.paymentGateway}
                        onChange={(e) => setSendData({...sendData, paymentGateway: e.target.checked === true ? 1 : 0})}
                      />
                      درگاه پرداخت
                    </label>
                  </div>
                </div>
                <div></div>
                {sendData?.paymentGateway === 1 &&
                  <DynaInput label={"کد اقتصادی *"}
                             name={"economicId"}
                             className={"solid-dyna-input"}
                             placeholder={"کد اقتصادی را وارد کنید"}
                             value={sendData?.economicId}
                             type={"text"}
                             setDataFromComponent={(data) => {
                               setSendData({...sendData, ...data})
                             }}
                  />}
                {sendData?.paymentGateway === 1 &&
                  <DynaInput label={"نام بانک *"}
                             name={"bankName"}
                             className={"solid-dyna-input"}
                             placeholder={"نام بانک را وارد کنید"}
                             value={sendData?.bankName}
                             type={"text"}
                             setDataFromComponent={(data) => {
                               setSendData({...sendData, ...data})
                             }}
                  />}
                {sendData?.paymentGateway === 1 &&
                  <DynaInput label={"شماره شبا *"}
                             name={"shebaNumber"}
                             className={"solid-dyna-input"}
                             placeholder={"شماره شبا را وارد کنید"}
                             value={sendData?.shebaNumber}
                             type={"text"}
                             setDataFromComponent={(data) => {
                               setSendData({...sendData, ...data})
                             }}
                  />}
                {sendData?.paymentGateway === 1 &&
                  <DynaInput label={"شمار حساب *"}
                             name={"accountNumber"}
                             className={"solid-dyna-input"}
                             placeholder={"شمار حساب را وارد کنید"}
                             value={sendData?.accountNumber}
                             type={"text"}
                             setDataFromComponent={(data) => {
                               setSendData({...sendData, ...data})
                             }}
                  />}
              </div>
            </section>

            <section className={"parent-section"}>
              <div className={"title-side"}>
                <ArrowIcon/>
                <h5>معرفی شعب و نمایندگی ها</h5>
              </div>
              <div className={"form-side"}>
                <div className="radio-button-group">
                  <h5>نمایندگی</h5>
                  <div className={"parent-row"}>
                    <label className="radio-label">
                      <input
                        type="radio"
                        name="hasAgent"
                        value={true}
                        checked={sendData?.hasAgent}
                        onChange={() => setSendData({...sendData, hasAgent: 1})}
                        className="radio-input"
                      />
                      <span className="custom-radio"></span>
                      دارد
                    </label>

                    <label className="radio-label">
                      <input
                        type="radio"
                        name="hasAgent"
                        value={false}
                        checked={!sendData?.hasAgent}
                        onChange={() => setSendData({...sendData, hasAgent: 0})}
                        className="radio-input"
                      />
                      <span className="custom-radio"></span>
                      ندارد
                    </label>
                  </div>
                </div>
                {sendData?.hasAgent === 1 && <>
                  <h4 style={{gridColumn: "1/-1"}}>جزییات معرفی مجموعه و یا شعب</h4>
                  <label className="radio-label">
                    <input style={{gridColumn: "1/-1"}}
                           type="checkbox"
                           name="paymentGateway"
                           checked={sendData?.googleMap}
                           onChange={(e) => setSendData({...sendData, googleMap: e.target.checked === true ? 1 : 0})}
                    />
                    معرفی مجموعه و یا شعب و جانمایی پراکندگی روی نقشه کشور و دنیا در گوگل مپ
                  </label>
                  <div style={{gridColumn: "1/-1"}}>
                    <DynaTextarea label={"نام و نشانی مجموعه و یا شعب"}
                                  name={"agentAddress"}
                                  style={{height: '140px'}}
                                  className={"solid-dyna-input"}
                                  placeholder={"نام و نشانی مجموعه و یا شعب را وارد کنید"}
                                  value={sendData?.agentAddress}
                                  type={"text"}
                                  setDataFromComponent={(data) => {
                                    setSendData({...sendData, ...data})
                                  }}
                    />
                  </div>
                </>}
              </div>
            </section>

            <section className={"parent-section"}>
              <div className={"title-side"}>
                <ArrowIcon/>
                <h5>بخش های(ماژول های) سایت</h5>
              </div>
              <div className={"form-side"} style={{gridGap: '20px'}}>
                {initialData?.modules && initialData?.modules.map((item, index) =>
                  <label className="radio-label" key={"modules" + index}>
                    <input
                      type="checkbox"
                      name="modules"
                      checked={+item?.check}
                      onChange={(e) => modulesHandler(e.target.checked, item?.id)}
                    />
                    {item?.title}
                  </label>
                )}
              </div>
            </section>

            <section className={"parent-section"}>
              <div className={"title-side"}>
                <ArrowIcon/>
                <h5>شبکه های اجتماعی</h5>
              </div>
              <div className={"form-side"}>
                {initialData?.socialMedia.length > 0 &&
                  <ul className={"socialMediaTable"}>
                    <li>
                      <h6 style={{width: "15%"}}>ردیف</h6>
                      <h6 style={{width: "35%"}}>نام شبکه اجتماعی</h6>
                      <h6 style={{width: "50%"}}>آدرس</h6>
                    </li>
                    {initialData?.socialMedia.map((item, index) =>
                      <li key={"socialMedia" + index}>
                        <h6 style={{width: "15%"}}>{index + 1}</h6>
                        <h6 style={{width: "35%"}}>{item?.title}</h6>
                        <input style={{width: "50%"}} value={item?.link} placeholder={"آدرس را وارد کنید"}
                               onChange={(e) => linkChangeHandler(e.target.value, item?.id)}/>
                      </li>
                    )}
                  </ul>
                }
              </div>
            </section>

            <section className={"parent-section"}>
              <div className={"title-side"}>
                <ArrowIcon/>
                <h5>افزودن فایل</h5>
              </div>
              <div className={"form-side"}>
                <div className={"parent-file-upload"}>
                  <label>کارت ملی</label>
                  <button onClick={() => document.getElementById("nationalCard").click()} className={"upload-file-but"}>
                    {fileName?.nationalCard}
                  </button>
                  <input style={{display: "none"}} type={"file"} id={"nationalCard"}
                         onChange={(e) => handleFileChange(e, "nationalCard")}/>
                  {sendData?.nationalCard_link !== "" &&
                    <a className={"show-link"} href={sendData?.nationalCard_link} target={"_blank"}><ShowIcon/></a>}
                  {sendData?.nationalCard_link !== "" &&
                    <button className={"delete-file"}
                            onClick={() => deleteFileHandler("nationalCard")}><DeleteIcon/></button>}
                </div>
                <div className={"parent-file-upload"}>
                  <label>مجوز فعالیت</label>
                  <button onClick={() => document.getElementById("license").click()} className={"upload-file-but"}>
                    {fileName?.license}
                  </button>
                  <input style={{display: "none"}} type={"file"} id={"license"}
                         onChange={(e) => handleFileChange(e, "license")}/>
                  {sendData?.license_link !== "" &&
                    <a className={"show-link"} href={sendData?.license_link} target={"_blank"}><ShowIcon/></a>}
                  {sendData?.license_link !== "" &&
                    <button className={"delete-file"}
                            onClick={() => deleteFileHandler("license")}><DeleteIcon/></button>}
                </div>
              </div>
            </section>

            <section className={"parent-section"}>
              <div className={"title-side"}>
                <ArrowIcon/>
                <h5>تنظیمات فروش</h5>
              </div>
              <div className={"form-side"}>
                <DynaInput label={"قیمت توافق شده"}
                           name={"agreedPrice"}
                           className={"solid-dyna-input"}
                           placeholder={"قیمت توافق شده را وارد کنید"}
                           value={UtilsFunctions.addCommas(sendData?.agreedPrice)}
                           type={"text"}
                           hasComma={true}
                           setDataFromComponent={(data) => {
                             setSendData({...sendData, ...data})
                           }}
                />
                <div style={{gridColumn: "1/-1"}}>
                  <DynaTextarea label={"توضیحات فاکتور"}
                                name={"factorDescription"}
                                style={{height: '100px'}}
                                className={"solid-dyna-input"}
                                placeholder={"توضیحات فاکتور را وارد کنید"}
                                value={sendData?.factorDescription}
                                type={"text"}
                                setDataFromComponent={(data) => {
                                  setSendData({...sendData, ...data})
                                }}
                  />
                </div>
              </div>
            </section>

            <section className={"parent-section"}>
              <div className={"title-side"}>
                <ArrowIcon/>
                <h5>تنظیمات مدیر فروش</h5>
              </div>
              <div className={"form-side"}>
                {sendData?.electronicSymbol === 1 &&
                  <DynaSelectBox options={initialData?.electronicSymbolStatus}
                                 hasFilter={false}
                                 label={"وضعیت اینماد *"}
                                 className={"solid-dyna-input"}
                                 value={sendData?.electronicSymbolStatus}
                                 onChange={(data) => setSendData({...sendData, electronicSymbolStatus: data?.value})}
                  />
                }
                {sendData?.paymentGateway === 1 &&
                  <DynaSelectBox options={initialData?.paymentGatewayStatus}
                                 hasFilter={false}
                                 label={"وضعیت درگاه پرداخت *"}
                                 className={"solid-dyna-input"}
                                 value={sendData?.paymentGatewayStatus}
                                 onChange={(data) => setSendData({...sendData, paymentGatewayStatus: data?.value})}
                  />
                }
                <DynaSelectBox options={initialData?.status}
                               hasFilter={false}
                               label={"وضعیت *"}
                               className={"solid-dyna-input"}
                               value={sendData?.status}
                               onChange={(data) => setSendData({...sendData, status: data?.value})}
                />
              </div>
            </section>

            <section className={"button-side"}>
              {!isPending &&
                <button onClick={submitDataHandler}>
                  {myLocation?.state?.mode === "edit" ? "ویرایش درخواست" : "افزودن"}</button>}
              {!isPending && <button className={"cansel-button"} onClick={() => navigateTo(-1)}>انصراف</button>}
              {isPending && <h6 className="pending-message">لطفاً صبر کنید، درخواست در حال ارسال است...</h6>}
            </section>

          </section> : <Loader/>}
      </>
    );
  } catch (e) {
    return <>{e.toLocaleString()}</>
  }
};

export default NewOrderForm;